import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box
} from "@mui/material";
import {
  Group,
  Inventory2,
  Category,
  ShoppingCart,
  Cancel
} from "@mui/icons-material";

const StatCard = ({ title, count, icon }) => (
  <Card sx={{ height: "100%" }}>
    <CardContent
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2
      }}
    >
      <Box
        sx={{
          backgroundColor: "#0b1f4d",
          color: "#fff",
          p: 1.8,
          borderRadius: 1
        }}
      >
        {icon}
      </Box>

      <Box>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "15px",
            color: "#0b1f4d"
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "20px",
            mt: 0.5
          }}
        >
          {count}
        </Typography>
      </Box>
    </CardContent>
  </Card>
);


function SummarySection({
  todayUsersCount = 0,
  todayProductsCount = 0,
  todayCategoriesCount = 0,
  todayOrdersCount = 0,
  todayFailedOrdersCount = 0
}) {
  return (
    <Grid container spacing={3} sx={{ mt: 1 }}>
      <Grid item xs={12} md={2.4}>
        <StatCard
          title="Users"
          count={todayUsersCount}
          icon={<Group />}
        />
      </Grid>

      <Grid item xs={12} md={2.4}>
        <StatCard
          title="Products"
          count={todayProductsCount}
          icon={<Inventory2 />}
        />
      </Grid>

      <Grid item xs={12} md={2.4}>
        <StatCard
          title="Categories"
          count={todayCategoriesCount}
          icon={<Category />}
        />
      </Grid>

      <Grid item xs={12} md={2.4}>
        <StatCard
          title="Orders Placed"
          count={todayOrdersCount}
          icon={<ShoppingCart />}
        />
      </Grid>

      <Grid item xs={12} md={2.4}>
        <StatCard
          title="Orders Failed"
          count={todayFailedOrdersCount}
          icon={<Cancel />}
        />
      </Grid>
    </Grid>
  );
}

export default SummarySection;
